module.exports = __webpack_public_path__ + "static/media/trustpilot-logo.62a8f66e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images/trustpilot-logo.svg
// module id = 617
// module chunks = 0